import Http from '@/utils/http/index';

export default {
  /**
   * 退款查询列表
   */
  getRefundList(params = {}) {
    const obj = {};
    const keys = Object.keys(params);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (!params.keywords) {
        obj[k] = params[k];
      } else if (k !== 'startTime' && k !== 'endTime') {
        // 当存在 keywords(流水号) 时，忽略时间限制
        obj[k] = params[k];
      }
    }
    if (obj.onlineRefundStatus && (typeof obj.onlineRefundStatus === 'object') && obj.onlineRefundStatus.length) {
      obj.onlineRefundStatus = obj.onlineRefundStatus.join(',');
    }
    return Http.get('/rf/listRefundApply', { params: obj });
  },

  /**
   * 下载退款列表
   */
  downloadRefund(params) {
    const obj = {
      ...params,
    };
    if (obj.onlineRefundStatus && (typeof obj.onlineRefundStatus === 'object') && obj.onlineRefundStatus.length) {
      obj.onlineRefundStatus = obj.onlineRefundStatus.join(',');
    }
    return Http.get('/rf/downloadRefundApply', { params: obj });
  },

  /**
   * 退款撤销
   */
  postRefundRevoke(param) {
    return Http.post('/rf/refundRevoke', param);
  },

};
